import { apiSlice } from '../../app/api/apiSlice'

export const authApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    auth: builder.mutation({
      query: (credentials) => ({
        url: '/bouser/auth',
        method: 'POST',
        body: { ...credentials },
      }),
    }),
    validate2FA: builder.mutation({
      query: (payload) => {
        return {
          url: '/bouser/auth/validate',
          method: 'POST',
          body: { ...payload },
        }
      },
    }),
    resend2FA: builder.mutation({
      query: (payload) => {
        return {
          url: '/bouser/auth/resendtwofa',
          method: 'PUT',
          body: { ...payload },
        }
      },
    }),
    user: builder.query({
      query: () => ({
        url: '/bouser',
      }),
    }),
    validateInvite: builder.mutation({
      query: (payload) => {
        return {
          url: '/bouser/auth/validateinvitation',
          method: 'POST',
          body: { ...payload },
        }
      },
    }),
    validateAppRecoveryCode: builder.mutation({
      query: (payload) => {
        return {
          url: '/user/verifyrecover',
          method: 'POST',
          body: { ...payload },
        }
      },
      transformResponse: (response, meta, arg) => {
        let parsedResponse = {
          message: response.message,
          success: response.success,
          user: { dni: response.user, token: response.token },
        }
        return parsedResponse
      },
    }),
    changeAppPassword: builder.mutation({
      query: ({ newPassword, dni, number, token }) => {
        return {
          url: '/auth/setrecover',
          method: 'POST',
          headers: { Authorization: `Bearer ${token}` },
          body: { newPassword, dni, number },
        }
      },
    }),
    changePassword: builder.mutation({
      query: ({ newPassword, email, number }) => {
        return {
          url: '/bouser/auth/setrecoverpassword',
          method: 'PUT',
          body: { newPassword, email, number },
        }
      },
    }),
  }),
  overrideExisting: true,
})

export const {
  useAuthMutation,
  useUserMutation,
  useValidate2FAMutation,
  useResend2FAMutation,
  useValidateInviteMutation,
  useValidateAppRecoveryCodeMutation,
  useChangePasswordMutation,
  useChangeAppPasswordMutation,
} = authApiSlice
